import Cepillo_Roller from "./Cepillo_Roller..jpg";
import Condimento_Escalonado from "./Condimento_Escalonado..jpg";
import Contenedor_Salchichas from "./Contenedor_Salchichas..jpg";
import Contenedor_Verduras from "./Contenedor_Verduras..jpg";
import Pinzas_Salchicha from "./Pinzas_Salchicha.jpg";
import Trapo_Azul from "./Trapo_Azul.jpg";

import cafeBote from "./cafeBote.jpg";
import cafeCafetera from "./cafeCafetera.jpg";
import cafesprite from "./cafesprite.png";

import maquinaPaso1 from "./MaquinaPaso1.png";
import maquinaPaso2 from "./MaquinaPaso2.png";
import maquinaPaso3 from "./MaquinaPaso3.png";
import maquinaPaso4 from "./MaquinaPaso4.png";
import maquinaPaso5 from "./MaquinaPaso5.png";

import CafeAmericano from "./CafeAmericano.jpg";
import CafeCapuchino from "./CafeCapuchino.jpg";
import CafeKobalto from "./CafeKobalto.jpg";
import CafeKrea from "./CafeKrea.jpg";
import CafeYelox from "./CafeYelox.jpg";

export const imgTema2 = {
	Cepillo_Roller,
	Condimento_Escalonado,
	Contenedor_Salchichas,
	Contenedor_Verduras,
	Pinzas_Salchicha,
	Trapo_Azul,
	cafeBote,
	cafeCafetera,
	cafesprite,
	maquinaPaso1,
	maquinaPaso2,
	maquinaPaso3,
	maquinaPaso4,
	maquinaPaso5,
	CafeAmericano,
	CafeCapuchino,
	CafeKobalto,
	CafeKrea,
	CafeYelox,
}